import React, {Component} from "react"
import ReactFullpage from '@fullpage/react-fullpage';
import Banner from "../../components/Banner/Banner.jsx";
import Footer from "../../components/Footer/Footer";
import "./Home.scss"
import About from "../../static/img/about.jpg"
import WelcomeImg from "../../static/img/welcome.jpg"
import Navs from "../../components/Navs/Navs";
import {NavLink} from "react-router-dom";


export default class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fullPageIndex: 0,
            newsIndex: 0,
            newsTabList: ["行业新闻", "公司新闻", "物流资讯"],
            homeGs: [{}, {}, {}, {}],
            cwCompanyNewsHome: {},
            cwCompanyNewsHomes: [],
            cwIndustryNewsHome: {},
            cwIndustryNewsHomes: [],
            cwLogisticsNewsHome: {},
            cwLogisticsNewsHomes: [],
            partnerPics: []
        }

    }

    componentDidMount() {
        this.$axios.apiList.getHomeData({})
            .then(res => {
                this.setState({
                    homeGs: res.data.homeGs,
                    cwCompanyNewsHome: res.data.cwCompanyNewsHome,
                    cwCompanyNewsHomes: res.data.cwCompanyNewsHomes,
                    cwIndustryNewsHome: res.data.cwIndustryNewsHome,
                    cwIndustryNewsHomes: res.data.cwIndustryNewsHomes,
                    cwLogisticsNewsHome: res.data.cwLogisticsNewsHome,
                    cwLogisticsNewsHomes: res.data.cwLogisticsNewsHomes,
                    partnerPics: res.data.partnerPics,

                })
            })
            .catch(error => {

            })
    }

    /* 整页切换 */
    onLeave(origin, destination, direction) {
        // console.debug("==================")
        // console.debug(destination)
        this.setState({
            fullPageIndex: destination.index,
        })
    }

    render() {
        let {
            fullPageIndex,
            newsIndex,
            newsTabList,
            homeGs,
            cwCompanyNewsHome,
            cwCompanyNewsHomes,
            cwIndustryNewsHome,
            cwIndustryNewsHomes,
            cwLogisticsNewsHome,
            cwLogisticsNewsHomes,
            partnerPics,
        } = this.state;
        let arrIcon = [{
            icon: "icon-shouye-bendihuoyuan",
            name: "本地货源"
        }, {
            icon: "icon-shouye-waidihuoyuan",
            name: "外地货源"
        }, {
            icon: "icon-shouye-quanguohuoyuan",
            name: "全国货源"
        }, {
            icon: "icon-shouye-zhengchepeihuo",
            name: "整车配货"
        }]
        homeGs.forEach((item, index) => {
            item.icon = arrIcon[index].icon;
            item.name = arrIcon[index].name;
        })
        let leftObj = {}, rightArr = [];
        switch (newsIndex) {
            case 0:
                leftObj = cwCompanyNewsHome;
                rightArr = cwCompanyNewsHomes;
                break;
            case 1:
                leftObj = cwIndustryNewsHome;
                rightArr = cwIndustryNewsHomes;
                break;
            case 2:
                leftObj = cwLogisticsNewsHome;
                rightArr = cwLogisticsNewsHomes;
                break;
            default:
                leftObj = cwCompanyNewsHome;
                rightArr = cwCompanyNewsHomes;
                break;
        }
        return (
            <div className="home">
                <Navs fullPageIndex={fullPageIndex}/>
                <ReactFullpage
                    licenseKey={'E80D319D-92914194-AABB73E8-03B75233'}
                    scrollingSpeed={1000} /* Options here */
                    anchors={['header', 'about', 'information', 'news', 'cooperation', 'footer',]}
                    onLeave={this.onLeave.bind(this)}
                    render={({state, fullPageApi}) => {
                        return (
                            <ReactFullpage.Wrapper>
                                <div className="section">
                                    <div className="section-wrapper section-banner">
                                        <Banner></Banner>
                                    </div>
                                </div>
                                <div className="section">
                                    <div className="section-wrapper section-about">
                                        <div>
                                            <div className="section-title">
                                                <div>ABOUT <span>US</span></div>
                                                <div>关于我们</div>
                                                <div>
                                                    <i className="iconfont icon-shouye-xiangxia"></i>
                                                </div>
                                            </div>
                                            <div className="about-content">
                                                <div className="left">
                                                    <img src={About} alt=""/>
                                                </div>
                                                <div className="center">
                                                    <div className="title">
                                                    宜兴市交运物流信息科技有限公司
                                                    </div>
                                                    <div className="text">
                                                        <p>
                                                        宜兴市交运物流信息科技有限公司，是一家专业从事物流行业网络货运服务的现代化物流科技公司。
                                                        </p>
                                                        <p>
                                                            公司成立于2018年，以先进的信息管理系统为平台、以现代物流技术为手段，构建综合运输网络和集货配送物流体系。目前本公司已建立起以宜兴市为中心，辐射全国的物流网络。一直以客户为中心，关注客户需求追求完美服务，具有绝对优势的输运经验。
                                                        </p>
                                                    </div>
                                                    <NavLink to="/about" className="btn">
                                                        立即查看
                                                    </NavLink>
                                                </div>
                                            </div>
                                            <div className="about-list">
                                                <div className="item">
                                                    <div className="box">
                                                        <div className="icon">
                                                            <i className="iconfont icon-shouye-yewufenbu"></i>
                                                        </div>
                                                        <div className="text">
                                                            业务分布
                                                        </div>
                                                    </div>
                                                    <div className="box-hover">
                                                        <div>
                                                            业务分布
                                                        </div>
                                                        <div>
                                                            Business Distribution
                                                        </div>
                                                        <div>
                                                            公司国内业务已遍及34个省市
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="item">
                                                    <div className="box">
                                                        <div className="icon">
                                                            <i className="iconfont icon-shouye-cheliangchuanbo"></i>
                                                        </div>
                                                        <div className="text">
                                                            车辆船舶
                                                        </div>
                                                    </div>
                                                    <div className="box-hover">
                                                        <div>
                                                            车辆船舶
                                                        </div>
                                                        <div>
                                                            Vehicle ship
                                                        </div>
                                                        <div>
                                                            公司合作的车辆船舶约有3万辆(艘)
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="item">
                                                    <div className="box">
                                                        <div className="icon">
                                                            <i className="iconfont icon-shouye-siji"></i>
                                                        </div>
                                                        <div className="text">
                                                            司机船主
                                                        </div>
                                                    </div>
                                                    <div className="box-hover">
                                                        <div>
                                                            司机船主
                                                        </div>
                                                        <div>
                                                            Driver shipowner
                                                        </div>
                                                        <div>
                                                            公司合作的司机船主约有6万人
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="item">
                                                    <div className="box">
                                                        <div className="icon">
                                                            <i className="iconfont icon-shouye-huoyunliang"></i>
                                                        </div>
                                                        <div className="text">
                                                            货运量
                                                        </div>
                                                    </div>
                                                    <div className="box-hover">
                                                        <div>
                                                            货运量
                                                        </div>
                                                        <div>
                                                            Freight volume
                                                        </div>
                                                        <div>
                                                            目前公司货运累计量已达8千万吨
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="section">
                                    <div className="section-wrapper section-information">
                                        <div className="information-content">
                                            <div>
                                                <div className="information-text">SUPPLY INFORMATION</div>
                                                <div className="information-title">
                                                    货源信息
                                                    <i className="iconfont icon-shouye-you"></i>
                                                </div>
                                                <div className="information-border"></div>
                                                <div className="information-list">
                                                    {
                                                        homeGs.map((item, index) => {
                                                            return item.date && (
                                                                <NavLink
                                                                    to={{
                                                                        pathname: "/information",
                                                                        query: {tabsIndex: index}
                                                                    }}
                                                                    className="item" key={index}>
                                                                    <div className="left">
                                                                        <i className={`iconfont ${item.icon}`}></i>
                                                                    </div>
                                                                    <div className="content">
                                                                        <div>{item.name}</div>
                                                                        <div>{item.loadPlace}→{item.unloadPlace}</div>
                                                                    </div>
                                                                    <div className="right">
                                                                        【{item.date}】
                                                                    </div>
                                                                </NavLink>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="section">
                                    <div className="section-wrapper section-news">
                                        <div>
                                            <div className="section-title">
                                                <div>News <span>Center</span></div>
                                                <div>新闻中心</div>
                                                <div>
                                                    <i className="iconfont icon-shouye-xiangxia"></i>
                                                </div>
                                            </div>
                                            <div className="news-content">
                                                <div className="news-tabs-top">
                                                    {
                                                        newsTabList.map((item, index) => {
                                                            return (
                                                                <div
                                                                    className={`item ${newsIndex === index ? "in" : null}`}
                                                                    key={index}
                                                                    onClick={e => {
                                                                        this.setState({newsIndex: index})
                                                                    }}>
                                                                    {item}
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                                <div className="news-tabs-content">
                                                    <div className="item">
                                                        <div className="left">
                                                            <div className="icon">
                                                                <img src={leftObj.imageUrl} alt=""/>
                                                            </div>
                                                            <div className="title">
                                                                {leftObj.title}
                                                            </div>
                                                            <div className="text">
                                                                {leftObj.content}
                                                            </div>
                                                            <NavLink to={`/newsDetails/${leftObj.id}`} className="btn">
                                                                查看更多
                                                            </NavLink>
                                                        </div>
                                                        <div className="right">
                                                            {
                                                                rightArr.map((item, index) => {
                                                                    return (
                                                                        <NavLink to={`/newsDetails/${item.id}`}
                                                                                 className="right-item" key={index}>
                                                                            <div className="item-left">
                                                                                <div className="title">
                                                                                    {
                                                                                        item.createTime.substring(item.createTime.length - 2, item.createTime.length)
                                                                                    }
                                                                                </div>
                                                                                <div className="text">
                                                                                    {item.createTime.substring(0, item.createTime.length - 3)}
                                                                                </div>
                                                                            </div>
                                                                            <div className="item-right">
                                                                                <div className="title">
                                                                                    {item.title}
                                                                                </div>
                                                                                <div className="text">
                                                                                    {item.content}
                                                                                </div>
                                                                            </div>
                                                                        </NavLink>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="section">
                                    <div className="section-wrapper section-cooperation">
                                        <div>
                                            <div className="cooperation-title">
                                                用心做服务 成就行业口碑影响力
                                            </div>
                                            <div className="top-list-title">
                                                <div className="item">
                                                    <div className="title">
                                                        10+<span>年</span>
                                                    </div>
                                                    <div className="text">
                                                        运输经验
                                                    </div>
                                                </div>
                                                <div className="item">
                                                    <div className="title">
                                                        56+<span>个</span>
                                                    </div>
                                                    <div className="text">
                                                        细分行业
                                                    </div>
                                                </div>
                                                <div className="item">
                                                    <div className="title">
                                                        500+<span>家</span>
                                                    </div>
                                                    <div className="text">
                                                        服务企业
                                                    </div>
                                                </div>
                                                <div className="item">
                                                    <div className="title">
                                                        10+<span>亿</span>
                                                    </div>
                                                    <div className="text">
                                                        投入资金
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="cooperation-content">
                                                {
                                                    partnerPics.map((item, index) => {
                                                        return (
                                                            <div className="item" key={index}>
                                                                <img src={item} alt=""/>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                            <NavLink to="/cooperation" className="cooperation-btn">
                                            更多案例 &gt;&gt;
                                            </NavLink>
                                        </div>
                                    </div>
                                </div>
                                <div className="section">
                                    <div className="section-wrapper section-footer">
                                        <div>
                                            <div className="welcome">
                                                <img src={WelcomeImg} alt=""/>
                                            </div>
                                            <Footer></Footer>
                                        </div>
                                    </div>
                                </div>
                            </ReactFullpage.Wrapper>
                        );
                    }}
                />
            </div>
        )
    }
}
